// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"04ff415e","455":"cac5988f","977":"19a0874e"}[chunkId] + ".chunk.js";
};